import React, { useRef } from "react";
import { UPLOAD_TIMESHEET_TEXT } from "./constant";
import { FileUploadInput } from "./fileUploadInput";
import { Button } from "antd";

export function TimeSheetButton({ title, onFileChange, toggleShowImage, loading }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileInput = useRef<any>(null);

  const handleClick = () => {
    if (title === UPLOAD_TIMESHEET_TEXT) {
      return fileInput.current?.click();
    }
    toggleShowImage();
  };

  return (
    <>
      <FileUploadInput onChange={onFileChange} inputRef={fileInput} />
      <Button
        loading={loading}
        /* @ts-expect-error FIXME this wrong type */
        type={title === UPLOAD_TIMESHEET_TEXT ? "danger" : "primary"}
        ghost
        onClick={handleClick}
        style={{
          margin: "10px",
          borderRadius: "2px",
        }}
      >
        {title}
      </Button>
    </>
  );
}
